/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SortDirection } from '../../models/sort-direction';
import { TransactionPagedList } from '../../models/transaction-paged-list';
import { TransactionSortFieldName } from '../../models/transaction-sort-field-name';

export interface SearchTransactionsOfAuthSupports$Any$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;

/**
 * The list items offset
 */
  offset?: number;

/**
 * The list items limit
 */
  limit?: number;

/**
 * Indicates the field to use for sorting the data:
 *   * START_DATE
 *   * DURATION
 *   * ENERGY
 *   * VOLUME
 *   * PROVIDER
 *   * PUMP_NUMBER
 *   * CARD_NUMBER
 *   * SUBSCRIPTION_NAME
 *   * STATION_NAME
 *   * SUBSERVICE_NAME
 */
  sortFieldName?: TransactionSortFieldName & any;

/**
 * Sort direction : ASC, DESC
 */
  sortDirection?: SortDirection & any;

/**
 * The start date time of data to filter
 */
  startDateTime?: string;

/**
 * The end date time of data to filter
 */
  endDateTime?: string;

/**
 * The search text to filter API
 */
  search?: string;
  
    /**
     * Body for search transaction
     */
    body?: any
}

export function searchTransactionsOfAuthSupports$Any(http: HttpClient, rootUrl: string, params: SearchTransactionsOfAuthSupports$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<TransactionPagedList>> {
  const rb = new RequestBuilder(rootUrl, searchTransactionsOfAuthSupports$Any.PATH, 'post');
  if (params) {
    rb.path('uid', params.uid, {});
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
    rb.query('sortFieldName', params.sortFieldName, {});
    rb.query('sortDirection', params.sortDirection, {});
    rb.query('startDateTime', params.startDateTime, {});
    rb.query('endDateTime', params.endDateTime, {});
    rb.query('search', params.search, {});
    rb.body(params.body, 'application/octet-stream');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TransactionPagedList>;
    })
  );
}

searchTransactionsOfAuthSupports$Any.PATH = '/auth-supports/{uid}/transactions/search';
